module.exports = __webpack_public_path__ + "/build/web/images/hero-testimonials@3x.7b63500a8ea20b715692c50e7e2dd00e.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/hero-testimonials@3x.jpg
// module id = 150
// module chunks = 13